import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import CTABand from "@/components/site/CTABand";
import { useT } from "@/context/ContentContext";

export default function Partenaires() {
  const [partners, setPartners] = useState([]);
  useEffect(() => { api.get("/partners").then(({ data }) => setPartners(data || [])); }, []);

  return (
    <div data-testid="page-partenaires">
      <section className="relative py-24 md:py-32 border-b border-ducs-gold/10">
        <div className="absolute inset-0 dijon-pattern opacity-30" aria-hidden />
        <div className="relative max-w-7xl mx-auto px-5 md:px-8">
          <div className="label-caps mb-5">{useT("partenaires.hero.eyebrow")}</div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-ducs-cream leading-tight tracking-tight max-w-4xl">
            {useT("partenaires.hero.title.line1")}<br />
            <span className="text-ducs-gold italic">{useT("partenaires.hero.title.accent")}</span>
          </h1>
          <div className="gold-divider mt-6" />
          <p className="mt-6 text-ducs-mist text-base md:text-lg leading-relaxed max-w-3xl whitespace-pre-line">
            {useT("partenaires.hero.intro")}
          </p>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">
            {partners.map((p) => (
              <div key={p.id} data-testid={`partner-${p.id}`} className="card-ducs aspect-[5/3] flex items-center justify-center text-center px-3">
                {p.logo_url
                  ? <img src={p.logo_url} alt={p.name} className="max-h-12 max-w-[140px] object-contain" />
                  : <span className="font-serif text-ducs-gold text-lg md:text-xl tracking-wide">{p.name}</span>}
              </div>
            ))}
          </div>
          {partners.length === 0 && (
            <div className="text-ducs-mist text-center py-20">Chargement des partenaires…</div>
          )}
        </div>
      </section>

      <CTABand
        eyebrow={useT("partenaires.cta.eyebrow")}
        title={useT("partenaires.cta.title")}
        subtitle={useT("partenaires.cta.subtitle")}
        primaryLabel={useT("partenaires.cta.button1")}
        secondaryLabel={useT("partenaires.cta.button2")}
      />
    </div>
  );
}
